import React from 'react';
import PropTypes from 'prop-types';

import { ToggleButton } from '@hydra/common/components';

import toArray from '@hydra/utils/toArray';

export default class ExpandableList extends React.Component {
  constructor () {
    super();
    this.state = {
      expanded: false
    };

    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand () {
    return this.setState(oldState => ({ expanded: !oldState.expanded }));
  }

  render () {
    const items = toArray(this.props.children);
    const canBeExpanded = items.length > this.props.itemsVisible;
    const visibleItems = this.state.expanded ? items : items.slice(0, this.props.itemsVisible);

    return (
      <>
        <div>
          {visibleItems}
        </div>
        {
          canBeExpanded
            ? <ToggleButton handleClick={this.toggleExpand} isActive={this.state.expanded} />
            : null
        }
      </>
    );
  }
}

ExpandableList.defaultProps = {
  itemsVisible: 5
};

ExpandableList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  itemsVisible: PropTypes.number
};
